import { isConversationIdNullOrPreRendered } from 'modules/conversations/utils'
import { toVisibleMessagesArray } from 'modules/message/utils'
import { isEmpty, last, pathOr } from 'ramda'
import { useSelector } from 'react-redux'
import { Message } from 'types/message'

const useLastAgentMessage = (): Partial<Message> => {
  const { activeConversation: activeConversationId } = useSelector(
    state => state.conversations
  )

  const lastAgentMessageFromActiveConversation = useSelector(state => {
    if (isConversationIdNullOrPreRendered(activeConversationId)) {
      return null
    }

    return (
      pathOr(
        null,
        [
          'conversations',
          'conversations',
          activeConversationId,
          'lastAgentMessage'
        ],
        state
      )
    )
  })

  const lastAgentMessageFromMessages = useSelector(state => {
    const messagesForActiveConversation = (
      pathOr(
        {},
        [
          'conversations',
          'messages',
          activeConversationId
        ],
        state
      )
    )

    if (
      isEmpty(messagesForActiveConversation) ||
      isConversationIdNullOrPreRendered(activeConversationId)
    ) {
      return null
    }

    const agentMessagesForActiveConversation = (
      toVisibleMessagesArray(messagesForActiveConversation)
        .filter(message => pathOr(null, ['authorType'], message) === "USER")
    )

    if (!!agentMessagesForActiveConversation.length) {
      return last(agentMessagesForActiveConversation)
    }
  })

  if (lastAgentMessageFromActiveConversation) {
    return lastAgentMessageFromActiveConversation
  }

  if (lastAgentMessageFromMessages) {
    return lastAgentMessageFromMessages
  }

  return {}
}

export default useLastAgentMessage
